import { sumBy } from "lodash";
import { computed, ref } from "vue-demi";

import { useApi } from "./api";

export function useMap() {
  const q = useApi("/dashboard/map", {
    defaultValue: {
      points: []
    },
    immediate: false
  });

  const measure = ref("");

  const markers = computed(() => {
    return q.data.value.points.map(el => [el.latitude, el.longitude]);
  });

  const clusterLabel = cluster => {
    const markers = cluster.getAllChildMarkers();

    const clusterData = markers.map(child => {
      const latLng = child.getLatLng();
      return q.data.value.points.find(
        el => el.latitude == latLng.lat && el.longitude == latLng.lng
      );
    });

    const computeMap = {
      turnover: () => {
        const number = clusterData.length;
        const value = sumBy(clusterData, "value");
        const total = sumBy(q.data.value.points, "value");
        const ratio = value / total;
        return { number, ratio, value };
      },
      promotion: () => {
        const number = clusterData.length;
        const value = sumBy(clusterData, "value");
        const total = sumBy(q.data.value.points, "value");
        const ratio = value / total;
        return { number, ratio, value };
      },
      default: () => {
        const number = clusterData.length;
        const total = q.data.value.points.length;
        const ratio = number / total;
        return { number, ratio, value: null };
      }
    };

    if (measure.value in computeMap) return computeMap[measure.value]();

    return computeMap.default();
  };

  const clear = () => {
    measure.value = null;
    q.clear();
  };

  return {
    ...q,
    clear,
    markers,
    measure,
    clusterLabel
  };
}
